import http from '../api'

let getAllConvenants = (data) => {
    return http.get(`health-plans-insurances/${data}&page=1&perPage=1000`)
}

export default {
    getAllConvenants,
}